module.exports = __webpack_public_path__ + "static/couple-computer-square.2cae7b31.jpg";